/** Ekran KDS zwracany przez `v3-listKdsDevices` (bez pól wrażliwych). */
export interface KdsDevice {
  deviceId: string;
  name: string | null;
  roomServiceId: string | null;
  /** Stanowisko w punkcie (`gastronomyPoints`); null = ekran widzi wszystkie stanowiska. */
  gastronomyPointId: string | null;
  /**
   * Skrót stanowiska z backendu. `gastronomyPointId` ustawione, a skrót null = stanowisko
   * usunięte w room service (tablet nadal ma stare przypisanie, trzeba je wyczyścić).
   */
  gastronomyPoint: KdsGastronomyPoint | null;
  model: string | null;
  appVersion: string | null;
  /** Milisekundy epoki albo null, gdy backend nie ma jeszcze znacznika. */
  pairedAt: number | null;
  lastSeenAt: number | null;
}

export interface KdsGastronomyPoint {
  id: string;
  name: string;
  color: string | null;
  /** Wyłączone stanowisko można przypisać (decyzja 2026-10-29), panel tylko je oznacza. */
  isActive: boolean;
}

/** Koperta odpowiedzi v3 (`{success, message, data}`). */
export interface KdsEnvelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface ClaimKdsDeviceRequest {
  hotelId: string;
  code: string;
  name?: string;
  roomServiceId?: string | null;
  /** Tylko razem z `roomServiceId`; pominięte albo null = wszystkie stanowiska. */
  gastronomyPointId?: string | null;
}

export interface ClaimKdsDeviceResult {
  deviceId: string;
  name: string;
  hotelId: string;
  roomServiceId: string | null;
}

/**
 * Zmiana punktu/stanowiska sparowanego ekranu (`v3-updateKdsDevice`).
 * Pominięte pole = bez zmian, null = wyczyść.
 */
export interface UpdateKdsDeviceRequest {
  hotelId: string;
  deviceId: string;
  roomServiceId?: string | null;
  gastronomyPointId?: string | null;
}

export interface UpdateKdsDeviceResult {
  deviceId: string;
  hotelId: string;
  roomServiceId: string | null;
  gastronomyPointId: string | null;
  gastronomyPoint: KdsGastronomyPoint | null;
}

export interface UnpairKdsDeviceRequest {
  hotelId: string;
  deviceId: string;
}

/**
 * Po ilu milisekundach bez kontaktu uznajemy ekran za offline. Tablet stempluje
 * `lastSeenAt` przy każdym odpytaniu o stan parowania (co kilkadziesiąt sekund),
 * więc pięć minut ciszy to już realna awaria, a nie chwilowe zacięcie sieci.
 */
export const KDS_ONLINE_THRESHOLD_MS = 5 * 60 * 1000;

export const isKdsDeviceOnline = (lastSeenAt: number | null): boolean => typeof lastSeenAt === 'number' && Date.now() - lastSeenAt < KDS_ONLINE_THRESHOLD_MS;

/** Klucz błędu, który backend v3 odsyła w `message` koperty (np. `kdsDevice.notFound`). */
export const kdsErrorKey = (err: { response?: { data?: unknown } }): string => (
  (err.response?.data as { message?: string } | undefined)?.message ?? ''
);
